if (!customElements.get('product-whatsapp-link')) {
  customElements.define(
    'product-whatsapp-link',
    class ProductWhatsappLink extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        this.handleClick = this.handleClick.bind(this);
        this.link?.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.link?.removeEventListener('click', this.handleClick);
      }

      handleClick() {
        const phone = this.dataset.phone;
        const message = this.dataset.message;
        const productTitle = this.dataset.productTitle;

        if (!this.link || !phone) return;

        const text = `${message} — ${productTitle}: ${window.location.href}`;
        this.link.href = `https://wa.me/${phone}?${new URLSearchParams({ text })}`;
      }
    }
  );
}
